// src/views/customer/unpaid/CustomerUnpaidCreditPage.jsx
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector }   from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  // ❌ admin-ish (don’t use from customer app):
  // getCustomerUnpaidCreditService,
  // ✅ customer-scoped:
  getCustomerCreditItemsService,
} from '@/services/CustomerServices';

import validationErrors from '@/lib/validationErrors';
import OutstandingCreditList from '../component/OutstandingCreditList';
import ToastMe from '@/components/ui/ToastMe';
import { setCustomerBearerToken } from '@/security/Axios';

const CustomerUnpaidCreditPage = () => {
  const dispatch  = useDispatch();
  const navigate  = useNavigate();
  const customer  = useSelector((s) => s.Auth.userData);
  const [rows, setRows] = useState([]);

  // Ensure we have a customer token and set it as the active Authorization header.
  useEffect(() => {
    const tok =
      localStorage.getItem('customer_jwt') ||
      localStorage.getItem('customerToken');

    if (!tok) {
      ToastMe('Please log in to view your unpaid credit.', 'error');
      navigate('/customer/login');
      return;
    }
    setCustomerBearerToken(tok); // 🔐 forces axios to use the customer JWT
  }, [navigate]);

  // Fetch UNPAID credit items via the customer endpoint
  useEffect(() => {
    if (!customer?._id) return;

    dispatch(
      getCustomerCreditItemsService({
        customerId: customer._id,
        status    : 'unpaid',
      })
    )
      .then((res) => {
        // shape: array of credit rows (backend-defined)
        setRows(res?.data?.data ?? []);
      })
      .catch(({ message, errorData }) => validationErrors(errorData, message));
  }, [customer, dispatch]);

  return (
    <div className="p-4">
      <h3 className="font-semibold text-xl mb-6">Unpaid Credit Orders</h3>
      <OutstandingCreditList rows={rows} />
    </div>
  );
};

export default CustomerUnpaidCreditPage;
